module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('li', [_c('div', {
    staticStyle: {
      "font-size": "16px"
    },
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [(_vm.isFolder) ? _c('i', {
    staticClass: "fa ",
    class: [_vm.open ? 'fa-minus-square-o' : 'fa-plus-square-o']
  }) : _vm._e(), _vm._v(" "), (_vm.isFolder) ? _c('i', {
    staticClass: "fa ",
    class: [_vm.open ? 'fa-folder-open' : 'fa-folder']
  }) : _vm._e(), _vm._v(" "), (!_vm.isFolder) ? _c('i', {
    staticClass: "fa fa-file-text"
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "menuname"
  }, [_vm._v(_vm._s(_vm.model.name))])]), _vm._v(" "), (_vm.isFolder) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }]
  }, _vm._l((_vm.model.children), function(item) {
    return _c('items', {
      attrs: {
        "model": item
      }
    })
  }), 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fba6f46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/treeselect.vue
// module id = 205
// module chunks = 1